import { cn } from '@/lib/utils';

interface BrandMarkProps {
  /** Tailwind height class; the mark keeps its own aspect ratio. */
  className?: string;
  /**
   * Accessible name. The mark spells "Go" (G + bee-as-o), so it defaults to the
   * full product name when it stands alone. Pass `alt="Go"` when a "WeeBee …"
   * wordmark already sits beside it, or the name reads twice.
   */
  alt?: string;
}

/**
 * The WeeBee Go mark on a transparent background.
 *
 * Two files rather than one: the mark's "G" is ink on light surfaces and honey
 * on dark ones, so a single cutout would go invisible in one of the two themes.
 * Only one is ever rendered (the other is `display:none`), so both carry the
 * same alt — otherwise the name vanishes in whichever theme isn't the default.
 *
 * The mark reads as letters, not as a symbol, so it belongs AFTER the wordmark:
 * "WeeBee" + "Go". Placing it first renders the product name backwards.
 */
export function BrandMark({ className, alt = 'WeeBee Go' }: BrandMarkProps) {
  const base = 'w-auto inline-block align-middle';
  return (
    <>
      <img
        src="/weebee-mark.png"
        alt={alt}
        className={cn(base, 'dark:hidden', className)}
      />
      <img
        src="/weebee-mark-dark.png"
        alt={alt}
        className={cn(base, 'hidden dark:inline-block', className)}
      />
    </>
  );
}
